
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1mabk_le0r8_94",
  "radio": "awsui_radio_1mabk_le0r8_106",
  "radio--has-description": "awsui_radio--has-description_1mabk_le0r8_114",
  "radio-control": "awsui_radio-control_1mabk_le0r8_118",
  "outline": "awsui_outline_1mabk_le0r8_126",
  "styled-circle-border": "awsui_styled-circle-border_1mabk_le0r8_145",
  "styled-circle-disabled": "awsui_styled-circle-disabled_1mabk_le0r8_149",
  "styled-circle-fill": "awsui_styled-circle-fill_1mabk_le0r8_154",
  "styled-circle-checked": "awsui_styled-circle-checked_1mabk_le0r8_160"
};
  